// extracted by mini-css-extract-plugin
module.exports = {"container":"EmptyPage_container__2TSLO","ImageSection":"EmptyPage_ImageSection__3Ejul"};